module.exports = __webpack_public_path__ + "static/media/pix.dce406fa.svg";